import {
    Component,
    Host,
    Prop,
    h,
    Watch,
    Element,
    Listen,
    State,
} from "@stencil/core";

/** This component is intended to be used with a child component that uses a lazy-load attribute */
@Component({
    tag: "ux-iws-lazy-tab",
    styleUrl: "lazy-tab.scss",
    shadow: true,
})
export class Tab {
    @Element() domNode: HTMLUxIwsLazyTabElement;

    /** Sets the name for the corresponding tab-button */
    @Prop({ reflect: true }) name: string = "";
    /** Sets ID for Tab */
    @Prop({ reflect: true }) tabId: string = "";
    /** lazy-load attribute-name used on child element. On activation that attribute is removed from the child */
    @Prop() lazyLoadAttribute: string = "lazy-load";

    /** Boolean to indicate active tab */
    @State() active: boolean = false;

    @Listen("uxActiveTabSet", { target: "document" })
    setActiveTab(event: CustomEvent) {
        if (
            this.domNode.closest("ux-tab-container") ===
            (event.target as HTMLElement)
        )
            this.active = event.detail === this.tabId;
    }

    async componentDidLoad() {
        this.lazyLoad();
    }

    @Watch("active")
    lazyLoad() {
        if (!this.active) return;
        this.domNode
            .querySelector(`[${this.lazyLoadAttribute}]`)
            ?.removeAttribute(this.lazyLoadAttribute);
    }

    render() {
        return (
            <Host
                class={{
                    ["is-active"]: this.active,
                }}
            >
                <slot />
            </Host>
        );
    }
}
